import {DataARLedgerListModel} from './data-ar-ledger-list.model';

export class SavePaymentDistributionsModel {
  PaymentID: string;
  ClientPostDate: Date;
  dataARLedgerItems: DataARLedgerListModel[];
  LOCID: number;
  DoctorARLocID: string;
  LedgerItemToVoid: string;
}
